// Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import { FunctionComponent, ReactElement } from "react";
import { Box, CardMedia, Grid, Paper, Stack, Typography } from "@mui/material";
import ErrorImg from '../images/error.svg';

type ErrorPagePropsInterface = {};

/**
 * error page.
 *
 * @param {ErrorPagePropsInterface} props - Props injected to the component.
 *
 * @return {React.ReactElement}
 */
export const ErrorPage: FunctionComponent<ErrorPagePropsInterface> = (): ReactElement => {
    return (
        <Box>
            <Box height="100vh" width="100vw" sx={{ display: "flex", flexDirection: "column", justifyContent: 'center', alignItems: 'center' }}>
                <Paper elevation={1} sx={{ height: "90vh", width: "95vw", display: "flex", justifyContent: 'center' }}>
                    <Stack direction="column" spacing={2} justifyContent="center" alignItems="center">
                        <CardMedia
                            sx={{ height: "40vh", width: "40vh" }}
                            component="img"
                            image={ErrorImg}
                            alt="Error Image"
                        />
                        <Typography p={3} align="center" variant="h3">Error!</Typography>
                        <Typography align="center" variant="h5">something went wrong.</Typography>
                    </Stack>
                </Paper>
            </Box>
        </Box>
    );
};

export const ErrorComponent: FunctionComponent<ErrorPagePropsInterface> = (): ReactElement => {
    return (
        <Grid container spacing={3} sx={{ height: "100%" }}>
            <Grid item xs={12} sx={{ height: "100%" }}>
                <Paper elevation={1} sx={{ height: "100%", display: "flex", justifyContent: 'center' }}>
                    <Stack direction="column" spacing={2} justifyContent="center" alignItems="center">
                        <CardMedia
                            sx={{ height: "40vh", width: "40vh" }}
                            component="img"
                            image={ErrorImg}
                            alt="Error Image"
                        />
                        <Typography p={3} align="center" variant="h3">Error!</Typography>
                        <Typography align="center" variant="h5">something went wrong.</Typography>
                    </Stack>
                </Paper>
            </Grid>
        </Grid>
    );
};

export const ErrorSubComponent: FunctionComponent<ErrorPagePropsInterface> = (): ReactElement => {
    return (
        <Grid container spacing={3}>
            <Grid item xs={3} >
            </Grid>
            <Grid item xs={6} >
                <Paper elevation={1} sx={{ display: "flex", justifyContent: 'center', padding: 3 }}>
                    <Stack direction="column" spacing={2} justifyContent="center" alignItems="center">
                        <CardMedia
                            sx={{ height: "40vh", width: "40vh" }}
                            component="img"
                            image={ErrorImg}
                            alt="Error Image"
                        />
                        <Typography p={3} align="center" variant="h3">Error!</Typography>
                        <Typography align="center" variant="h5">something went wrong.</Typography>
                    </Stack>
                </Paper>
            </Grid>
            <Grid item xs={3} >
            </Grid>
        </Grid>
    );
};
